import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeo } from '../../data/seo';
import { useContent } from '../../content/ContentContext';
import { TOPICS } from '../../data/topics';
import { COACHING_FORM, PRICES, DROP_IN } from '../../data/content';
import { COURSE_DETAILS } from '../../data/courses';

const meta = (key, name, content) => {
  let node = document.head.querySelector(`meta[${key}="${name}"]`);
  if (!node) { node = document.createElement('meta'); node.setAttribute(key, name); document.head.appendChild(node); }
  node.content = content;
};

export const Seo = () => {
  const { pathname } = useLocation();
  const { faq, team } = useContent();
  useEffect(() => {
    const topicFaq = (pathname.replace(/\/+$/, '') === '/coaching' ? COACHING_FORM.faq : TOPICS[pathname.replace(/^\/+|\/+$/g, '')]?.faq)?.map(([q, a]) => ({ q, a }));
    const seo = getSeo(pathname, process.env.REACT_APP_BACKEND_URL, topicFaq || faq, { team, courses: COURSE_DETAILS, prices: PRICES, dropIn: DROP_IN });
    document.title = seo.title;
    meta('name', 'description', seo.description);
    meta('name', 'robots', seo.robots);
    for (const [name, content] of Object.entries({ 'og:type': 'website', 'og:site_name': 'FlensFitness', 'og:locale': 'de_DE', 'og:title': seo.title, 'og:description': seo.description, 'og:url': seo.canonical, 'og:image': seo.image, 'og:image:width': '1200', 'og:image:height': '630', 'og:image:alt': 'Die FlensFitness-Community in Flensburg' })) meta('property', name, content);
    for (const [name, content] of Object.entries({ 'twitter:card': 'summary_large_image', 'twitter:title': seo.title, 'twitter:description': seo.description, 'twitter:image': seo.image })) meta('name', name, content);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = seo.canonical;
    document.getElementById('seo-structured-data')?.remove();
    if (seo.structuredData) {
      const script = document.createElement('script');
      script.id = 'seo-structured-data'; script.type = 'application/ld+json';
      script.textContent = JSON.stringify(seo.structuredData);
      document.head.appendChild(script);
    }
  }, [pathname, faq, team]);
  return null;
};

export const PageScroll = () => {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (!hash) { try { window.scrollTo({ top: 0, behavior: 'instant' }); } catch { window.scrollTo(0, 0); } return undefined; }
    const id = decodeURIComponent(hash.slice(1));
    const started = performance.now();
    let frame, stopped = false;
    const jump = (el) => { try { el.scrollIntoView({ behavior: 'instant', block: 'start' }); } catch { el.scrollIntoView(true); } };
    const stop = () => { stopped = true; };
    const events = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    events.forEach((e) => window.addEventListener(e, stop, { passive: true }));
    const tick = () => {
      if (stopped) return;
      const el = document.getElementById(id);
      const elapsed = performance.now() - started;
      if (el) {
        if (Math.abs(el.getBoundingClientRect().top - (parseFloat(getComputedStyle(el).scrollMarginTop) || 0)) > 2) jump(el);
        if (elapsed > 4000) return;
      } else if (elapsed > 5000) return;
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(frame); events.forEach((e) => window.removeEventListener(e, stop)); };
  }, [pathname, hash, key]);
  return null;
};
